var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevertButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11430_100249)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11430_100249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6251 11.5015C16.6251 11.1564 16.3452 10.8765 16.0001 10.8765C15.6549 10.8765 15.3751 11.1564 15.3751 11.5015H16.6251ZM16.0001 17.2158H15.3751C15.3751 17.4526 15.5088 17.669 15.7206 17.7748L16.0001 17.2158ZM19.4348 19.632C19.7436 19.7863 20.119 19.6612 20.2734 19.3525C20.4277 19.0437 20.3026 18.6683 19.9939 18.5139L19.4348 19.632ZM25.6456 18.7881C25.725 18.4521 25.517 18.1155 25.181 18.0361C24.8451 17.9568 24.5085 18.1648 24.4291 18.5007L25.6456 18.7881ZM23.6855 12.5047C23.8451 12.8108 24.2225 12.9296 24.5286 12.7701C24.8347 12.6105 24.9536 12.2331 24.794 11.927L23.6855 12.5047ZM25.9108 9.35868C25.9108 9.0135 25.631 8.73368 25.2858 8.73368C24.9406 8.73368 24.6608 9.0135 24.6608 9.35868H25.9108ZM25.2858 12.9301V13.5551C25.631 13.5551 25.9108 13.2753 25.9108 12.9301H25.2858ZM21.7144 12.3051C21.3692 12.3051 21.0894 12.5849 21.0894 12.9301C21.0894 13.2753 21.3692 13.5551 21.7144 13.5551V12.3051ZM15.3751 11.5015V17.2158H16.6251V11.5015H15.3751ZM15.7206 17.7748L19.4348 19.632L19.9939 18.5139L16.2796 16.6568L15.7206 17.7748ZM24.4291 18.5007C23.5268 22.3203 20.0946 25.1622 16.0001 25.1622V26.4122C20.6873 26.4122 24.6131 23.159 25.6456 18.7881L24.4291 18.5007ZM16.0001 25.1622C11.2169 25.1622 7.33936 21.2848 7.33936 16.5015H6.08936C6.08936 21.9751 10.5265 26.4122 16.0001 26.4122V25.1622ZM7.33936 16.5015C7.33936 11.7184 11.2169 7.84082 16.0001 7.84082V6.59082C10.5265 6.59082 6.08936 11.028 6.08936 16.5015H7.33936ZM16.0001 7.84082C19.3405 7.84082 22.2404 9.73184 23.6855 12.5047L24.794 11.927C23.142 8.75726 19.8245 6.59082 16.0001 6.59082V7.84082ZM24.6608 9.35868V12.9301H25.9108V9.35868H24.6608ZM25.2858 12.3051H21.7144V13.5551H25.2858V12.3051Z",
    fill: "#aa1a5f"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11430_100249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11430_100249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertButton);
export default __webpack_public_path__ + "static/media/revertButton.e059a7255ac7294707f497c717d16326.svg";
export { ForwardRef as ReactComponent };